<template>
  <div class="remotekey">
    remotekey
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'RemotekeyModule',
  props: [
    'locale',
    'isNew',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  computed: {
    style () {
      const detail = this.item.detail.smartkey
      return {
        ...detail.size && detail.size !== 'default' && {
          fontSize: `${detail.size}px`
        },
        textAlign: detail.align
      }
    },
    isRemotekey () {
      const detail = this.item.detail
      return detail.remotekey && detail.remotekey.active
    }
  }
}
</script>
